var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"app","dark":""}},[_c('v-main',[_c('v-container',{attrs:{"fluid":""}},[_c('router-view'),_c('Loading'),_c('Alerts'),_c('Gif')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }